<template>
  <div>
    <b-form>
      <div class="form-group flex-inline-form-lg">
        <b-input-group class="fill-width">
          <b-input-group-text slot="prepend">
            <i class="fa fa-search"></i>
          </b-input-group-text>
          <b-form-input
            type="text"
            placeholder="Search location by name"
            @input="onChangeSearchQuery($event)"
            v-model="searchQuery"></b-form-input>
        </b-input-group>
        <b-input-group v-if="!hideCompanySelect">
          <company-multi-select
              :multiple="false"
              type="CUSTOMER"
              @on-selected="onCompanySelected"
            />
        </b-input-group>
        <b-input-group style="min-width: 150px;">
          <b-form-select
            v-model="sortType"
            @change="onChangeSortType($event)"
            :options="sortOptions" />
        </b-input-group>
        <b-input-group v-if="!hideUpload">
          <b-button v-b-toggle.upload-container variant="default" class="w-100"><i class="fa fa-upload"></i></b-button>
        </b-input-group>
        <b-input-group>
          <b-button @click="createLocation()" variant="success" class="w-100">New location &nbsp;<i class="fa fa-plus"></i></b-button>
        </b-input-group>
      </div>
    </b-form>
    <div>
      <b-collapse id="upload-container">
        <b-card>
          <b-form v-on:submit.prevent="onSubmitUpload">
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>Company</label>
                <company-multi-select
                  v-model="selectedCompany"
                  :multiple="false"
                  type="CUSTOMER"
                  @on-selected="onCompanyUploadSelected"
                  />
              </div>
            </div>
            <div v-show="!uploadProcessed">
              <b-form-file class="mb-2" ref="fileInput" :multiple="false" :state="Boolean(fileUpload)" v-model="fileUpload" name="fileInput" accept=".xml, .xls, .xlsx"></b-form-file>
              <br> Selected file: {{fileUpload && fileUpload.name}}
            </div>
            <b-alert show v-show="uploadProcessed" v-bind:variant="uploadAlert">
              <p style="margin-bottom: 0px;">
                {{ uploadResultText }}
                <a href="#" v-on:click.prevent="uploadProcessed = false; uploadText = 'Start Upload'" class="alert-link">Upload again.</a>
              </p>
            </b-alert>
            <hr>
            <b-button :disabled="noFileUploadChosen" type="submit" variant="primary">{{uploadText}}</b-button>
            <b-button
              @click="cancelUpload()"
              v-b-toggle="'upload-container'"
              type="reset"
              variant="outline-danger"
              class="pull-right">Cancel</b-button>
          </b-form>
        </b-card>
      </b-collapse>
    </div>
    <b-overlay :show="isLocationListLoading">
      <b-list-group class="no-box" v-if="totalRows">
        <b-list-group-item
          v-for="location in locations"
          :key="location.id"
          >
          <div class="pull-left">
            <router-link :to="'/shipment_md/locations/' + location.id"><strong>{{location.code}}</strong>
            </router-link>
            <p class="mb-1">{{location.name}}</p>
            <p class="mb-1" v-if="location.company"><strong>{{location.company.name}}</strong></p>
            <small :title="formatDateTime(location.created_at)">Created at: {{formatDateDistance(location.created_at)}}</small>
          </div>
          <div class="pull-right">
            <b-button @click="editLocation(location.id)" variant="outline-primary"><i class="fa fa-pencil-square-o"></i>&nbsp; Edit</b-button>
            <b-dropdown variant="outline-primary" class="m-md-2">
              <i class="fa fa-gear" slot="button-content"></i>
              <b-dropdown-item v-b-modal.delete_location @click="deleteLocationId = location.id" class="text-danger">Remove</b-dropdown-item>
            </b-dropdown>
          </div>
        </b-list-group-item>
      </b-list-group>
      <div style="height:150px;" v-if="isLocationListLoading && totalRows === 0"></div>
    </b-overlay>
    <b-pagination class="mt-3" align="center" size="md" :total-rows="totalRows" v-model="currentPage" :per-page="query_count" v-if="totalRows">
    </b-pagination>
    <b-alert show v-if="isFetched & totalRows === 0">No data available.</b-alert>
    <b-modal
      id="delete_location"
      title="Delete Location"
      header-bg-variant="danger"
      ok-variant="danger"
      @ok="deleteLocation(deleteLocationId)">
      <p class="my-4">Are you sure do you want to delete this location ?</p>
    </b-modal>
  </div>
</template>
<script>
import dateMixin from '@/mixins/date';
import routeQuery from '@/mixins/route_query';
import { debounce, isEmpty, cloneDeep, get, isString } from 'lodash';
import tmsApi from '@/api/tmsApi';
import CompanyMultiSelect from '@/components/CompanyMultiSelect';

export default {
  components: {
    CompanyMultiSelect,
  },
  name: 'location_table',
  mixins: [dateMixin, routeQuery],
  props: {
    companyId: {
      type: String,
      required: false,
      default: '',
    },
    hideUpload: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      deleteLocationId: '',
      companySelectorLoading: false,
      companyList: [],
      loaded: false,
      searchQuery: '',
      dataBeforeLoad: [],
      is_data_loaded: false,
      currentPage: 1,
      sortOptions: [
        { value: null, text: '== Sort by ==', disabled: true },
        { value: 'NAME.ASC', text: 'Name A-Z' },
        { value: 'NAME.DESC', text: 'Name Z-A' },
        { value: 'CODE.ASC', text: 'Code 0-9' },
        { value: 'CODE.DESC', text: 'Code 9-0' },
      ],
      selectedCompany: null,
      sortType: null,
      uploadProcessed: false,
      isStillUpload: false,
      fileUpload: null,
      uploadResult: false,
      uploadResultText: '',
      shipmentFile: true,
      selectedCustomer: '',
      uploadText: 'Start Upload',
    };
  },
  created() {
    this.$store.commit('shipment_md/locations/CLEAR_QUERY');
    if (!this.isSystemAdmin) {
      const { company_id: id } = this.userData;
      if (this.isAdmin) {
        this.$store.commit('shipment_md/locations/SET_QUERY_PARENT_ID', id);
      } else {
        this.$store.commit('shipment_md/locations/SET_QUERY_COMPANY_ID', id);
      }
    }
    this.initFromUrl();
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
    locations() {
      return this.$store.getters['shipment_md/locations/locations'];
    },
    count_all() {
      return this.$store.getters['shipment_md/locations/count_all'];
    },
    query_count() {
      return this.$store.getters['shipment_md/locations/query_count'];
    },
    totalRows() {
      return this.count_all;
    },
    userData() {
      return this.$store.getters.userData;
    },
    isSystemAdmin() {
      const { type } = this.userData;
      return type === 'SYSTEM_ADMIN';
    },
    loadLocation() {
      return this.$store.getters['shipment_md/locations/loadLocation'];
    },
    isLocationListLoading() {
      return this.loadLocation === 'LOADING';
    },
    isFetched() {
      return this.loadLocation === 'LOADED';
    },
    isAdmin() {
      const { type } = this.userData;
      return type === 'ADMIN';
    },
    hideCompanySelect() {
      return this.companyId !== '';
    },
    noFileUploadChosen() {
      return this.fileUpload == null || this.selectedCustomer === '' || this.isStillUpload;
    },
    uploadAlert() {
      return this.uploadResult ? 'success' : 'danger';
    },
  },
  watch: {
    currentPage(newValue) {
      this.is_data_loaded = false;
      this.dataBeforeLoad = cloneDeep(this.locations);
      setTimeout(() => {
        this.$store.commit('shipment_md/locations/SET_QUERY_PAGE', newValue);
        this.loadData();
      }, 1e3);
    },
  },
  methods: {
    initFromUrl() {
      let fCompanyId = this.getRouteQuery('company_id');
      const sort = this.getRouteQuery('sort');
      const search = this.getRouteQuery('q');

      if (this.companyId !== '') {
        fCompanyId = this.companyId;
      }

      if (typeof fCompanyId !== 'undefined') {
        this.setCompanyId({ id: fCompanyId }, true);
      }
      if (sort !== undefined) {
        this.onChangeSortType(sort, true);
      }
      if (search !== undefined) {
        this.onChangeSearchQuery(search, true);
      }

      this.loadInfoAndData();
    },
    onDropdown() {
      if (this.companyList.length > 0) return false;
      return this.$store.dispatch('companies/FREE_SEARCH_DATA', { value: '' }).then(({ data }) => {
        const { companies } = data;
        this.companyList = companies.filter((c, index) => index <= 4);
      });
    },
    updateSearchQuery: debounce((context, searchTerm) => {
      const searchQuery = isString(searchTerm) ? searchTerm.trim() : '';
      context.$store.commit('shipment_md/locations/SET_QUERY_SEARCH', searchQuery);
      context.loadInfoAndData();
    }, 500),
    onCompanySelected(selected) {
      this.selectedCompany = selected;
      this.setCompanyId(selected);
      this.loadInfoAndData();
    },
    setCompanyId(selected, fromInit = false) {
      if (typeof selected !== 'undefined' && selected !== null) {
        this.$store.commit('shipment_md/locations/SET_QUERY_COMPANY_ID', selected.id);
        const currId = this.getRouteQuery('company_id', '');
        if (!fromInit && selected.id !== currId) {
          this.setRouteQuery('company_id', selected.id);
        }
      } else {
        this.$store.commit('shipment_md/locations/SET_QUERY_COMPANY_ID', null);
        if (!fromInit) {
          this.removeRouteQuery('company_id');
        }
      }
    },
    onChangeSortType(newValue, fromInit = false) {
      if (!fromInit) {
        this.setRouteQuery('sort', newValue);
      }
      this.$store.commit('shipment_md/locations/SET_QUERY_SORT', newValue);
      this.sortType = newValue;

      if (!fromInit) {
        this.loadData();
      }
    },
    onChangeSearchQuery(newValue, fromInit = false) {
      this.$store.commit('shipment_md/locations/SET_QUERY_SEARCH', newValue);
      if (!fromInit) {
        if (!isEmpty(newValue)) {
          this.setRouteQuery('q', newValue);
        } else {
          this.removeRouteQuery('q');
        }
      }
      this.searchQuery = newValue;

      if (!fromInit) {
        this.updateSearchQuery(this, newValue);
      }
    },
    loadInfoAndData() {
      this.$store.dispatch('shipment_md/locations/LOAD_INFO');
      this.loadData();
    },
    loadData() {
      return this.$store.dispatch('shipment_md/locations/LOAD_DATA');
    },
    createLocation() {
      const companyId = get(this.selectedCompany, 'id', null);
      this.$router.push({ path: '/shipment_md/locations/create', query: { company_id: companyId } });
    },
    editLocation(id) {
      this.$router.push(`/shipment_md/locations/${id}/edit`);
    },
    deleteLocation(locationId) {
      this.$store.dispatch('shipment_md/locations/DELETE_DATA', locationId).then((ok) => {
        if (ok) {
          this.searchQuery = '';
          this.$store.dispatch('shipment_md/locations/LOAD_INFO');
          this.$store.dispatch('shipment_md/locations/LOAD_DATA');
        }
      });
    },
    cancelUpload() {
      this.$refs.fileInput.reset();
      this.uploadProcessed = false;
      this.isStillUpload = false;
      this.uploadText = 'Start Upload';
    },
    onCompanyUploadSelected(selected) {
      this.selectedCustomer = selected;
    },
    onSubmitUpload() {
      const { id: company_id } = this.selectedCustomer;
      this.isStillUpload = true;
      this.uploadText = 'Uploading';
      tmsApi.uploadAuth(this.token, { file: this.fileUpload }, {
        company_id,
        file_type: 'location',
      }).then((res) => {
        const isSuccessGenFile = get(res, 'status') === 'success';

        if (isSuccessGenFile) {
          this.uploadText = 'Success';
          this.uploadResultText = 'Success Upload File';
          this.$refs.fileInput.reset();
          this.uploadResult = isSuccessGenFile;
          this.uploadProcessed = true;
          this.loadData();
        } else {
          this.uploadText = 'Failed';
          this.uploadResult = false;
          this.uploadProcessed = true;
          this.uploadResultText = 'Failed Upload File';
        }
        this.isStillUpload = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shipment_md/LocationTable.vue